import { PageHeader } from "../page-header/PageHeader";
import { MyH1 } from "../../UI/my-h1/MyH1";
import { Container } from "../../UI/container/Container";
import { Card, Grid } from "@mantine/core";
import Image from "next/image";
import { SpecialtyData } from "../../../hooks/react-query/useSpecialtyList";
import { useColors } from "../../../hooks/colors/useColors";
import { MultiData } from "../../../hooks/react-query/useMultiList";
import {
  SpecialistData,
  useSpecialistList,
} from "../../../hooks/react-query/useSpecialistList";
import { Fragment, useEffect, useState } from "react";
import { SpecialistCard } from "../homepage/specialists/SpecialistCard";
import { useTranslation } from "next-i18next";
import { mobile, tablet } from "../../../constants/env";
import { ContentVisualizer } from "../content-visualizer/ContentVisualizer";
import { IconCalendarEvent } from "@tabler/icons";
import { ButtonLink } from "../../UI/button-link/ButtonLink";
import { isMobile } from "react-device-detect";
import { Footer } from "../homepage/footer/Footer";

type InputProps = {
  data: SpecialtyData | MultiData;
};

export function DisplaySpecialtyPage(props: InputProps) {
  const { data } = props;
  const { colors } = useColors();
  const { specialists } = useSpecialistList();
  const [areaSpecialists, setAreaSpecialists] = useState<SpecialistData[]>([]);
  const { t } = useTranslation("common");

  // set area specialists
  useEffect(() => {
    if (specialists && data) {
      const filteredSpecialists: SpecialistData[] = [];
      Object.keys(specialists).map((key) => {
        const specialist: SpecialistData = specialists[key];

        if (specialist.categories) {
          specialist.categories.forEach((category) => {
            if (
              category
                .replaceAll(".", "")
                .replaceAll(" ", "")
                .includes(data.name.replaceAll(".", "").replaceAll(" ", ""))
            )
              if (
                !filteredSpecialists
                  .map((spec) => spec.name)
                  .includes(specialist.name)
              )
                filteredSpecialists.push(specialist);
          });
        }
      });

      setAreaSpecialists(filteredSpecialists);
    }
  }, [specialists, data]);

  let imageClass = "p-0 flex relative w-[320px] h-[180px]";
  if (!mobile) imageClass = "p-0 flex relative w-[1152px] h-[648px]";
  if (tablet) imageClass = "p-0 flex relative w-[480px] h-[270px]";

  return (
    <Fragment>
      <PageHeader>
        <MyH1
          size={isMobile ? "1.8rem" : "2.6rem"}
          className="text-center"
          color="white"
        >
          {data.name}
        </MyH1>
      </PageHeader>
      <Container noHeight>
        {data.image && data.image.length > 10 && (
          <div
            className="flex justify-center"
            style={{ marginTop: -50, marginBottom: 50 }}
          >
            <Card className={imageClass} radius="xs" shadow="md">
              <Image
                priority
                alt="Person"
                src={data.image}
                sizes="1152px 480px 320px"
                fill
                style={{
                  objectFit: "cover",
                }}
              />
            </Card>
          </div>
        )}
        <ContentVisualizer content={data.content} />
        {areaSpecialists.length > 0 && (
          <div className="my-10">
            <h2
              color={colors.secondary}
              className="text-center text-4xl"
              style={{ color: colors.primary }}
            >
              {t("area-specialists")}
            </h2>
            <Grid>
              {areaSpecialists.map((specialist, index) => {
                return (
                  <Grid.Col
                    key={specialist.urlSlug}
                    span={{ base: 12, md: 6, lg: 4 }}
                    className="flex justify-center"
                  >
                    <SpecialistCard specialist={specialist} />
                  </Grid.Col>
                );
              })}
            </Grid>
          </div>
        )}
        <div className="flex justify-center my-8">
          <ButtonLink
            className="w-[300px] h-[50px]"
            href="/agendar"
            uppercase
            color={colors.secondary}
            title={t("book-app")}
            icon={<IconCalendarEvent color={colors.white} />}
            rounded
          />
        </div>
      </Container>
      <Footer isVisible delay />
    </Fragment>
  );
}
